import { gql } from "@apollo/client";

export const VALIDATE_PHONE_NUMBER = gql`
  query CheckPhoneNumber($phone: String!, $type: CheckPhoneNumberEnum!) {
    CheckPhoneNumber(input: { phone: $phone, type: $type }) {
      valid
    }
  }
`;
